import { useTranslation } from 'react-i18next';
import './NewImportanceBadge.css';

export type NewImportanceLevel = 'required' | 'recommended' | 'optional';

export interface NewImportanceBadgeProps {
  level: NewImportanceLevel;
  label?: string;
  className?: string;
}

const LEVEL_LABEL_KEY: Record<NewImportanceLevel, string> = {
  required: 'PIM.IMPORTANCE.REQUIRED',
  recommended: 'PIM.IMPORTANCE.RECOMMENDED',
  optional: 'PIM.IMPORTANCE.OPTIONAL',
};

/**
 * NewImportanceBadge — colour-coded pill indicating field importance level.
 * Required = green, Recommended = orange, Optional = grey.
 */
function NewImportanceBadge({ level, label, className }: NewImportanceBadgeProps) {
  const { t: tRaw } = useTranslation('pim');
  const t = (key: string): string => String(tRaw(key));
  const rootClass = [
    'new-importance-badge',
    `new-importance-badge--${level}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return <span className={rootClass}>{label ?? t(LEVEL_LABEL_KEY[level])}</span>;
}

export default NewImportanceBadge;
